import Route from "@/scripts/routeRegistrar"
const RouteRegistrar = new Route('forum');

RouteRegistrar.add("forum/forums/Forum", "messages", "forums", "مدیریت پرسش و پاسخ")

const routes = RouteRegistrar.allRoutes()


export default routes;
